import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es adecuado si tengo Hashimoto?',
  a: 'Sí, absolutamente. Las recetas están diseñadas con un enfoque antiinflamatorio, evitando ingredientes que suelen desencadenar brotes autoinmunes, ideal para personas con tiroiditis de Hashimoto.'
}, {
  q: '¿Los ingredientes son caros o difíciles de conseguir?',
  a: 'Para nada. Nos aseguramos de que el 95% de los ingredientes los puedas encontrar en tu supermercado o verdulería local. No necesitas comprar superalimentos costosos ni productos importados.'
}, {
  q: '¿Cómo recibo el recetario?',
  a: 'Una vez confirmado el pago, recibirás inmediatamente un correo electrónico con el enlace para descargar el recetario y todos los bonos en formato PDF. Podrás guardarlos en tu celular, tablet o computadora para siempre.'
}, {
  q: '¿Puedo leerlo desde mi celular?',
  a: '¡Sí! El formato PDF está optimizado para que puedas leerlo cómodamente desde cualquier dispositivo, ideal para llevarlo contigo a la cocina o al supermercado.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes nuestra garantía incondicional de 7 días. Si revisas el material y sientes que no es lo que esperabas, nos escribes un correo y te reembolsamos el 100% de tu dinero sin hacer preguntas.'
}];
export const FAQ = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <Section className="bg-white" data-id="element-83">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-84">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-85">
          Preguntas Frecuentes
        </h2>
        <p className="text-lg text-stone-600" data-id="element-86">
          Resolvemos tus dudas antes de empezar.
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-87">
        {faqs.map((faq, idx) => <div key={idx} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${openIdx === idx ? 'border-brand-300 bg-brand-50/30' : 'border-stone-200 bg-white hover:border-brand-200'}`} data-id="element-88">
            <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-89">
              <span className="font-bold text-stone-900 pr-8" data-id="element-90">{faq.q}</span>
              <ChevronDownIcon className={`w-5 h-5 text-brand-600 shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-91" />
            </button>

            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-92">
              <p className="text-stone-600 leading-relaxed" data-id="element-93">{faq.a}</p>
            </div>
          </div>)}
      </div>
    </Section>;
};